import { type IPasswordRecoveryCode } from '@shared/services';
import { publicApi } from '../../client';

export type ConfirmRecoveryCodeRequestParams = IPasswordRecoveryCode;

export const confirmRecoveryCodeRequest = async (params: ConfirmRecoveryCodeRequestParams) => {
  await publicApi.post('/api/v1/auth/check-recovery-code', params);
};
